import { useCallback, useEffect, useState } from 'react';
import { useNetwork } from '@/lib/use-network';
import { usePendentesCount } from '@/lib/use-pendentes';
import { sincronizarAgora, SYNC_EVENT_NAME } from '@/lib/sync';

export function SyncBadge() {
  const { online } = useNetwork();
  const pending = usePendentesCount();
  const [syncing, setSyncing] = useState(false);

  useEffect(() => {
    const handler = (e: Event) => {
      const detail = (e as CustomEvent).detail as { running?: boolean } | undefined;
      if (detail?.running !== undefined) setSyncing(detail.running);
    };
    window.addEventListener(SYNC_EVENT_NAME, handler);
    return () => window.removeEventListener(SYNC_EVENT_NAME, handler);
  }, []);

  const onClick = useCallback(() => {
    setSyncing(true);
    void sincronizarAgora().finally(() => setSyncing(false));
  }, []);

  let label: string;
  let color: string;
  let dot: string;

  if (!online && pending > 0) {
    color = 'bg-rose-500/20 text-rose-100 ring-rose-300/40';
    dot = 'bg-rose-400';
    label = `${pending} offline`;
  } else if (online && pending > 0) {
    color = 'bg-emerald-500/20 text-emerald-100 ring-emerald-300/40';
    dot = 'bg-emerald-400 animate-pulse';
    label = syncing ? `Sincronizando ${pending}...` : `${pending} pendente${pending > 1 ? 's' : ''}`;
  } else if (online) {
    color = 'bg-sky-500/20 text-sky-100 ring-sky-300/40';
    dot = 'bg-sky-400';
    label = 'Online';
  } else {
    color = 'bg-gray-500/20 text-gray-100 ring-gray-300/40';
    dot = 'bg-gray-400';
    label = 'Offline';
  }

  return (
    <button
      type="button"
      onClick={onClick}
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium ring-1 ring-inset ${color}`}
      title={online ? 'Clique para sincronizar agora' : 'Sem conexão'}
    >
      <span aria-hidden className={`h-2 w-2 rounded-full ${dot}`} />
      <span>{label}</span>
    </button>
  );
}

export default SyncBadge;
